import React from "react";
import { Link } from "react-router-dom";
export default function ReportRecentListItem(props) {
  const clickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
    }
  };

  const dblClickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
      props.onPick(props);
    }
  };

  let created = props.created ? new Date(props.created) : {};
  return (
    <>
      <Link
        onClick={(e) => clickHandler(e)}
        onDoubleClick={(e) => dblClickHandler(e)}
        to={`/report/${props.mode}/${props.nodeId}/${props.itemId}/${props.itemMode}/${props.id}/`}
      >
        <div
          className={`row py-4 px-2 border-bottom text-dark bg-hover-light ${
            props.highlightItem === String(props.id) ? "bg-light" : ""
          }`}
        >
          <div className="col-lg-12 m-lg-0 my-3">
            <div>
              {created.toLocaleString()}
              <span className="ml-2 text-dark-50">{props.opername}</span>
            </div>

            {props.description && (
              <div className="text-dark-75 small">{props.description}</div>
            )}
          </div>
        </div>
      </Link>
    </>
  );
}
